// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // host_api: 'http://localhost:8000/',
  // host_api: 'http://ec2-3-111-24-36.ap-south-1.compute.amazonaws.com/', // old backend
  // host_api: 'http://ec2-13-235-142-240.ap-south-1.compute.amazonaws.com/' // new backend
  host_api: 'https://api.avyaysolutions.in/' // domain backend
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
